import React, { memo } from "react";

const CallDetailPanelLoader = () => (
  <div className="callDetailPanelLoader">
    <div className="callDetailPanelLoaderHeader">
      <div className="callDetailPanelLoaderHeaderTop">
        <div className="callDetailPanelLoaderNameBlock">
          <span className="callDetailPanelLoaderName linear-background" />
          <div className="callDetailPanelLoaderMetaRow">
            <span className="callDetailPanelLoaderMetaChip linear-background" />
            <span className="callDetailPanelLoaderMetaChip linear-background" />
            <span className="callDetailPanelLoaderMetaChip linear-background" />
          </div>
        </div>
        <span className="callDetailPanelLoaderOutcome linear-background" />
      </div>
      <span className="callDetailPanelLoaderAudioBar linear-background" />
    </div>

    <div className="callDetailPanelLoaderTabs">
      <span className="callDetailPanelLoaderTab linear-background" />
      <span className="callDetailPanelLoaderTab linear-background" />
      <span className="callDetailPanelLoaderTab linear-background" />
    </div>

    <div className="callDetailPanelLoaderBody">
      <span className="callDetailPanelLoaderSectionLabel linear-background" />
      <span className="callDetailPanelLoaderTextBlock linear-background" />
      <span className="callDetailPanelLoaderTextBlock linear-background" />
      <span className="callDetailPanelLoaderTextBlockShort linear-background" />

      <div className="callDetailPanelLoaderDivider" />

      <span className="callDetailPanelLoaderSectionLabel linear-background" />
      <div className="callDetailPanelLoaderGrid">
        {Array.from({ length: 6 }, (_, i) => (
          <div key={i} className="callDetailPanelLoaderGridItem">
            <span className="callDetailPanelLoaderGridLabel linear-background" />
            <span className="callDetailPanelLoaderGridValue linear-background" />
          </div>
        ))}
      </div>
    </div>
  </div>
);

export default memo(CallDetailPanelLoader);
